module.exports = __webpack_public_path__ + "static/media/19ESCAP34.a17ae8b1.jpg";